import type { VariantCatalog } from "../types";

export function findCombination(
  catalog: VariantCatalog,
  values: readonly string[],
) {
  return catalog.combinations.find((combination) =>
    combination.values.every((value, index) => value === values[index]),
  );
}
